class HammockProductInfo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.flashSaleCallout = this.querySelector('.flash-sale-callout');
    this.suffixsizeFlashSaleDateLabel();
  }
  suffixsizeFlashSaleDateLabel() {
    const label = this.flashSaleCallout.querySelector('.label');
    const suffixes = ["th", "st", "nd", "rd"];
    if (label) {
      let dateText = label.textContent.trim();
      let [month, day] = dateText.split(' ');

      day = +day;
      day = day + (suffixes[(day - 20) % 10] || suffixes[day] || suffixes[0]);
      label.textContent = `${month} ${day}`;
    }
  }
}
customElements.define('hammock-product-info', HammockProductInfo);

class BundlePickerOption extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.productForm = document.querySelector('product-form');
    this.button = this.querySelector('.bundle-handle');
    this.button.addEventListener('change', this.onBundleSelected.bind(this));
    if (+this.dataset.defaultSelected === 1) {
      this.button.checked = true;
      this.button.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  get variantIdInput() {
    return this.productForm.querySelector('[name=id]');
  }
  get productIdInput() {
    return this.productForm.querySelector('[name=product-id]')
  }
  onBundleSelected() {
    this.variantIdInput.value = this.dataset.variantId;
    this.productIdInput.value = this.dataset.productId;
  }
}
customElements.define('bundle-picker-option', BundlePickerOption);
